import Index from '../../Modules/Department/Index';
import * as auth from '../../services/auth';

export default [
    {
        name: 'departments',
        path: '/admins/departments',
        component: Index,
        beforeEnter(to, from, next) {
            if (!auth.isLoggedIn()) {
                next('/')
            } else {
                next();
            }
        }
    },
]
